import { render, staticRenderFns } from "./ProjectSettingsPersonas.vue?vue&type=template&id=2010ac9c&scoped=true"
import script from "./ProjectSettingsPersonas.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsPersonas.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsPersonas.vue?vue&type=style&index=0&id=2010ac9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010ac9c",
  null
  
)

export default component.exports